import { apiAuthClient } from 'shared/api/lib/apiAuthClient';
import type { Batch } from '../types';

export const getBatches = async ({
  pathParams: { userBatchId },
}: {
  pathParams: { userBatchId: string };
}) => {
  const url = `/api/v2/batches/${userBatchId}`;

  const { data } = await apiAuthClient.get<{
    data: Batch;
  }>(url);

  return data.data;
};
